import { authManager } from 'lib-shared-auth';
import type {
  CreateAppLoginApiArg,
  CreateAppLoginApiResponse,
  CreateLoginTokenApiResponse,
  CreateOktaLoginApiArg,
  CreateOktaLoginApiResponse,
  DeleteAppLoginApiArg,
  DeleteAppLoginApiResponse,
  ReadAuthMethodApiResponse,
  ReadAuthOrganizationsApiResponse,
} from 'lib-shared-types-api';

import { api } from 'app/app.api';

import { transformReadAuthMethodResponse } from './utils/transformResponse';

export const loginApi = api.injectEndpoints({
  endpoints: (builder) => ({
    readAuthMethod: builder.query<ReadAuthMethodApiResponse, void>({
      query: () => ({
        version: 1,
        path: 'login/auth_methods',
        auth: false,
      }),
      transformResponse: transformReadAuthMethodResponse,
    }),
    createOktaLogin: builder.mutation<
      CreateOktaLoginApiResponse,
      CreateOktaLoginApiArg
    >({
      query: ({ accessToken: ot }) => ({
        version: authManager
          .isSupported()
          .then((isSupported) => (isSupported ? 2 : 1)),
        method: 'POST',
        path: 'login/okta',
        params: { ot },
        auth: false,
      }),
    }),
    createAppLogin: builder.mutation<
      CreateAppLoginApiResponse,
      CreateAppLoginApiArg
    >({
      query: ({ loginToken: lt, organizationId: org_id }) => ({
        version: authManager
          .isSupported()
          .then((isSupported) => (isSupported ? 2 : 1)),
        method: 'POST',
        path: 'login/application',
        params: { lt },
        body: { org_id },
        auth: false,
      }),
    }),
    deleteAppLogin: builder.mutation<
      DeleteAppLoginApiResponse,
      DeleteAppLoginApiArg
    >({
      query: ({ refreshToken: refresh_token }) => ({
        version: authManager
          .isSupported()
          .then((isSupported) => (isSupported ? 2 : 1)),
        method: 'DELETE',
        path: 'login/application',
        body: { refresh_token },
      }),
    }),
    readAuthOrganizations: builder.query<
      ReadAuthOrganizationsApiResponse,
      void
    >({
      query: () => ({
        version: 2,
        path: 'login/organizations',
      }),
    }),
    createLoginToken: builder.mutation<CreateLoginTokenApiResponse, void>({
      query: () => ({
        version: 2,
        method: 'POST',
        path: 'login/login_token',
      }),
    }),
  }),
});
